<!--
  Created by Caroline on 2019/11/25 0025.
-->
<template>
  <div class="container">
<!--    <div class="center" :style="'transform: scale(' + win.screenWScale > win.screenHScale ? win.screenHScale : win.screenWScale + ')'">-->
    <div class="center" :style="centerStyle">
      <div class="left">
        <div class="txt1">扫描二维码</div>
        <div class="txt2">祝福上墙</div>
        <div class="qr">
          <img :src="blessingData.qrcodeUrl" alt="" class="qrcode"/>
        </div>
      </div>
  
      <ul class="list">
        <transition-group name="list">
          <li v-for="(item, index) in displayList" :key="item.key"
              class="item" :class="index "
              :ref="'item_' + index">
            <div class="item--inner">
              <div class="item--left">
                <img :src="item.user.headImgUrl" alt="" class="item--head"/>
              </div>
              <div class="item--right">
                <span class="item--name" v-text="item.user.nickname"></span>
                <span class="item--content" v-text="item.content"></span>
              </div>
            </div>
          </li>
        </transition-group>
      </ul>
  
    </div>
  </div>
</template>

<script>
  // import BScroll from 'better-scroll'
  import {mapActions, mapState, mapGetters} from 'vuex'

  export default {
    name: "bless",
    data() {
      return {
        list: [],   // blessingList 的备份，用于循环向 displayList 输出
        displayList: [],
        newList: [],
        blessingInterv: null,
  
        curKey: 0,
        loopStartNum: 4,      // 开启循环的条数
        loopMax: 10,
        curLoopNewCount: 0,   // 积累能够开启循环的祝福条数
        isLooping: true,
        delay: 3000,
  
      }
    },
    computed: {
      ...mapState(['win', 'activityId', 'blessingData']),
      ...mapGetters(['scale', 'newBlessing', 'blessingList']),
      centerStyle () {
        let style = {
          'transform': 'scale(' + this.scale + ')',
        }
        this.win.screenWScale === 1 ? style['margin'] = 'auto' : style['margin-left'] = this.mainML
        style.bottom = (this.scale-1) * this.win.winHeight + 'px'
        return style
      },
      mainML () {
        let mainML = (1650-this.win.winWidth)/2/this.win.winWidth
        mainML = (-mainML*100).toFixed(2) + "%"
        return mainML
      },
    },
    watch: {
      blessingList(val) {
        if(val.length > 0){
          this.initBlessingListTemp()
        }
      },
      newBlessing(val) {
        this.newList.push(val)
        this.curLoopNewCount ++
        if(!this.isLooping && this.blessingList.length <= this.loopStartNum){
          this.startBlessingLoop()
        }
      },
    },
    created() {
    
    },
    mounted() {
      if(this.blessingList.length > 0){
        this.initBlessingListTemp()
      }
      this.startBlessingLoop()
    },
    beforeDestroy () {
      clearInterval(this.blessingInterv)
    },
    methods: {
      ...mapActions(['updateBlessingListByNew', 'getAllBlessingList']),
      initBlessingListTemp () {
        this.list = JSON.parse(JSON.stringify(this.blessingList))
      },
      startBlessingLoop() {
        this.isLooping = true
        clearInterval(this.blessingInterv)
        this.blessingInterv = setInterval(() => {
          if(this.blessingList.length <= this.loopStartNum && !this.list.length && !this.newList.length){
            this.isLooping = false
            clearInterval(this.blessingInterv)
            return
          }
          this.addBlessingInit()
        }, this.delay)
      },
      addBlessingInit(){
        this.curKey++
        let blessing = this.displayList.length && this.newList.length ? this.newList.shift() : this.list.shift()
        blessing ? blessing.key = this.curKey : ''
        this.addBlessing(blessing)
        // 删除顶部祝福
        if(this.displayList.length > this.loopMax){
          this.removeFirstBlessing()
        }
        // 一轮循环结束
        if(!this.newList.length && !this.list.length){
          this.loopEnd()
        }
      },
      addBlessing (blessing) {
        this.displayList.push(JSON.parse(JSON.stringify(blessing)))
      },
      removeFirstBlessing () {
        this.displayList.shift()
      },
      loopEnd () {
        if(this.blessingList.length + this.curLoopNewCount > this.loopStartNum){
          this.getAllBlessingList()
          this.isLooping = true
          this.curLoopNewCount = 0
        }
      },
      
    }
  }
</script>

<style scoped lang="less">
  @import "../less/common.less";
  @import "../less/bless.less";

</style>



// WEBPACK FOOTER //
// src/components/bless.vue